import React, { useState } from "react";
import "./Portfolio2026.scss";
import companies from "./data/companies";
import Sidebar from "./components/Sidebar";
import MobileHeader from "./components/MobileHeader";
import HomeView from "./components/HomeView";
import AboutView from "./components/AboutView";
import ContactView from "./components/ContactView";
import CaseStudyView from "./components/CaseStudyView";

// Sidebar-driven portfolio SPA, ported from the static HTML prototype.
// Navigation is handled entirely with local state (no new routes) so the
// page-switching behavior — including scroll position, the mobile drawer,
// and the scrollspy-highlighted nav — matches the original exactly.
function Portfolio2026() {
  const [page, setPage] = useState("home"); // 'home' | 'about' | 'contact' | 'cs'
  const [activeCase, setActiveCase] = useState({ ci: 0, pi: 0 });
  const [activeCompany, setActiveCompany] = useState(0);
  const [expanded, setExpanded] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);

  function navigate(nextPage) {
    setPage(nextPage);
    setDrawerOpen(false);
    window.scrollTo({ top: 0 });
  }

  function openCaseStudy(ci, pi) {
    setActiveCase({ ci, pi });
    setPage("cs");
    setDrawerOpen(false);
  }

  function handleCompanyClick(ci) {
    setActiveCompany(ci);
    const el = document.getElementById(companies[ci].id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function toggleExpand(ci) {
    setExpanded((prevState) => {
      const willBeOpen = !prevState[ci];
      if (!willBeOpen) {
        // mirrors the original's "scroll back up on collapse" behavior
        requestAnimationFrame(() => {
          const el = document.getElementById(companies[ci].id);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      }
      return { ...prevState, [ci]: willBeOpen };
    });
  }

  return (
    <div className="portfolio2026">
      <MobileHeader
        page={page}
        companies={companies}
        activeCompany={activeCompany}
        drawerOpen={drawerOpen}
        onToggleDrawer={() => setDrawerOpen((v) => !v)}
        onNavigate={navigate}
        onCompanyClick={handleCompanyClick}
      />

      <div className="shell">
        {page !== "cs" && (
          <Sidebar
            page={page}
            companies={companies}
            activeCompany={activeCompany}
            onNavigateHome={() => navigate("home")}
            onCompanyClick={handleCompanyClick}
            onNavigate={navigate}
          />
        )}

        <div className="page-content">
          {page === "home" && (
            <HomeView
              companies={companies}
              expanded={expanded}
              onToggleExpand={toggleExpand}
              onOpenCaseStudy={openCaseStudy}
              onActiveCompanyChange={setActiveCompany}
            />
          )}
          {page === "about" && <AboutView />}
          {page === "contact" && <ContactView />}
          {page === "cs" && (
            <CaseStudyView
              companies={companies}
              ci={activeCase.ci}
              pi={activeCase.pi}
              onBack={() => navigate("home")}
              onNavigate={navigate}
              onOpenCaseStudy={openCaseStudy}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Portfolio2026;
